import { FormProps } from "antd";

export const ticketTemplateFormLayout: Pick<
  FormProps,
  "labelCol" | "wrapperCol" | "labelAlign"
> = {
  wrapperCol: {
    xs: { span: 0 },
    md: { span: 8 },
    xl: { span: 6 },
    xxl: { span: 5 },
  },
  labelCol: {
    xs: { span: 0 },
    md: { span: 8 },
    xl: { span: 4 },
    xxl: { span: 3 },
  },
};

export const TICKET_TEMPLATE_TAB_NAMES = {
  info: "info",
  tickets: "tickets",
};
